module.exports = __webpack_public_path__ + "static/media/auth_logo.90675602.png";